
const API_BASE_URL = '';

/**
 * 汎用的なAPIリクエスト関数
 * @param {string} endpoint APIのエンドポイント (例: '/posts')
 * @param {RequestInit} [options={}] fetchのオプション (method, headers, bodyなど)
 * @returns {Promise<any>} 処理結果のデータ
 * @throws {Error} エラーが発生した場合
 */
async function safeFetch(
  endpoint,
  options = {}
) {
  const url = `${API_BASE_URL}${endpoint}`;

  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);

    console.log(response)

    // 2xx以外のHTTPステータスコードはエラーとして扱う
    if (!response.ok) {
      let errorBody = {};
      try {
        // エラーレスポンスがJSON形式の場合を試みる
        errorBody = await response.json();
      } catch (e) {
        // JSONでなければ、テキストとして取得
        errorBody = { message: await response.text() };
      }

      // より具体的なエラーメッセージをスロー
      throw new Error(
        `HTTP Error: ${response.status} ${response.statusText} - ${errorBody.message || 'Unknown error'}`
      );
    }

    // 204 No Content の場合はボディがないのでそのままnullを返す
    if (response.status === 204) {
      return null;
    }

    // レスポンスボディのJSON解析を試みる
    try {
      return await response.json();
    } catch (e) {
      // JSON形式でない、または解析に失敗した場合
      throw new Error(`JSON parsing error: ${e.message}`);
    }

  } catch (error) {
    // ネットワークエラー、CORSエラー、AbortControllerによる中断など
    if (error.name === 'AbortError') {
      throw new Error('Request timed out or aborted.');
    }
    // その他のネットワーク関連のエラー
    throw new Error(`Network or Fetch Error: ${error.message}`);
  }
}

// HTTPメソッドごとのラッパー関数
export const api = {
  get: (endpoint, options) => safeFetch(endpoint, { method: 'GET', ...options }),
  post: (endpoint, body, options) =>
    safeFetch(endpoint, { method: 'POST', body: JSON.stringify(body), ...options }),
  put: (endpoint, body, options) =>
    safeFetch(endpoint, { method: 'PUT', body: JSON.stringify(body), ...options }),
  del: (endpoint, options) => safeFetch(endpoint, { method: 'DELETE', ...options }),
};
